import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import toast from 'react-hot-toast';
import { Box, Link, Typography } from '@mui/material';
import { LoginUI } from '../../components/authentication/login';
import { register } from '../../constants/routing';
import { ContentContainer, Divider, SplitHalf, WorkforceSection, WrapperStyled } from '../../components/authentication/common';
import useAuth from '../../hooks/useAuth';
import ForgotPassword from './ForgotPassword';
import { useAppConfig } from '../../hooks/useConfig';
const Login = () => {
    var _a;
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const authContext = useAuth();
    const [searchParams, _] = useSearchParams();
    const returnTo = (_a = searchParams.get('returnTo')) !== null && _a !== void 0 ? _a : undefined;
    const config = useAppConfig();
    let onForgotPassword;
    if (authContext.authenticationManager.accountManager) {
        onForgotPassword = () => setShowForgotPassword(true);
    }
    else if (authContext.authenticationManager.accountLinks) {
        const accountLinks = authContext.authenticationManager.accountLinks;
        onForgotPassword = () => {
            window.location.href = accountLinks.forgotPasswordLink;
        };
    }
    else {
        onForgotPassword = () => {
            toast.error('Forgot password is not supported');
        };
    }
    if (showForgotPassword) {
        return _jsx(ForgotPassword, {});
    }
    function RegistrationLink() {
        if (authContext.authenticationManager.accountManager) {
            return (_jsx(Link, { color: "textSecondary", component: RouterLink, to: returnTo ? `${register()}?returnTo=${returnTo}` : register(), variant: "body1", children: "Create your account." }));
        }
        else if (authContext.authenticationManager.accountLinks) {
            return _jsx(Link, { href: authContext.authenticationManager.accountLinks.signUpLink, children: "Create your account now." });
        }
        else {
            return _jsx(_Fragment, { children: "Contact your Administrator." });
        }
    }
    return (_jsxs(WrapperStyled, { children: [_jsx(Helmet, { children: _jsx("title", { children: `Login | ${config.APP_NAME}` }) }), _jsxs(Box, { style: Object.assign({}, ContentContainer), children: [_jsx(WorkforceSection, {}), _jsx(Divider, {}), _jsxs(Box, { sx: Object.assign(Object.assign({}, SplitHalf), { right: 0, margin: 0 }), children: [_jsx(Box, { sx: {
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }, children: _jsxs("div", { children: [_jsx(Typography, { color: "textPrimary", gutterBottom: true, variant: "h1", style: { fontSize: '2.25', fontWeight: '500' }, children: "Sign in" }), _jsx(Typography, { color: "textPrimary", gutterBottom: true, variant: "body1", children: "Access your account." })] }) }), _jsx(Box, { sx: {
                                    flexGrow: 1,
                                    mt: 3,
                                }, children: _jsx(LoginUI, { returnTo: returnTo, allowedReturnOrigins: config.allowedReturnOrigins, onForgotPassword: onForgotPassword }) }), config.enableRegistration && (_jsx(Box, { className: 'max-width', textAlign: "center", p: 3, children: _jsxs(Typography, { color: "textPrimary", gutterBottom: true, variant: "body1", align: "center", children: ["Don't have an account?\u00A0", _jsx(RegistrationLink, {})] }) }))] })] })] }));
};
export default Login;
//# sourceMappingURL=Login.js.map